import Keycloak from 'keycloak-js';

const realm= process.env.REACT_APP_KEYCLOAK_REALM as string;
const url= process.env.REACT_APP_KEYCLOAK_URL as string;
const clientId= process.env.REACT_APP_KEYCLOAK_CLIENT_ID as string;


const keycloak = new Keycloak({
    realm: realm,
    url: url,
    clientId: clientId
});

const getSubscription = () => {
    const clientId = "farmcalendar";
    const roles = keycloak.tokenParsed?.resource_access?.[clientId]?.roles || [];

    if (roles.includes("basic")) {
        return "Basic Plan";
    }
    if (roles.includes("free")) {
        return "Free Plan";
    }

    return "Keine Subscription";
};



export default keycloak;
export { getSubscription };